import { createRouter, createWebHistory } from 'vue-router'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'default',
      component: () => import('@/components/endpoints/Default.vue')
    },
    {
      path: '/map',
      name: 'Map',
      component: () => import('@/components/endpoints/StaticMap.vue')
    },
    {
      path: '/detail',
      name: 'Detail',
      component: () => import('@/components/endpoints/Detail.vue')
    },
    {
      path: '/status',
      name: 'Status',
      component: () => import('@/components/endpoints/Status.vue')
    },
    {
      path: '/turnout',
      name: 'Turnout',
      component: () => import('@/components/endpoints/Turnout.vue')
    },
    {
      path: '/directcandidate',
      name: 'DirectCandidate',
      component: () => import('@/components/endpoints/DirectCandidate.vue')
    },
    {
      path: '/runoff',
      name: 'DirectCandidateRunoff',
      component: () => import('@/components/endpoints/Runoff.vue')
    },
    {
      path: '/multirunoff',
      name: 'MultiRunoff',
      component: () => import('@/components/endpoints/MultiRunoff.vue')
    },
    {
      path: '/optionspie',
      name: 'OptionsPie',
      component: () => import('@/components/endpoints/OptionsPie.vue')
    },
    {
      path: '/optioncandidatetable',
      name: 'OptionCandidateTable',
      component: () => import('@/components/endpoints/OptionCandidates.vue')
    },
    {
      path: '/diffbar',
      name: 'DiffBar',
      component: () => import('@/components/endpoints/DiffBar.vue')
    },
    {
      path: '/projection',
      name: 'Projection',
      component: () => import('@/components/endpoints/Projection.vue')
    },
    {
      path: '/projectionparliament',
      name: 'ProjectionParliament',
      component: () => import('@/components/endpoints/ProjectionParliament.vue')
    },
    {
      path: '/stcandidate',
      name: 'STCandidate',
      component: () => import('@/components/endpoints/StCandidates.vue')
    },
    {
      path: '/coalition',
      name: 'CoalitionCalculator',
      component: () => import('@/components/endpoints/CoalitionCalculator.vue')
    },
    {
      path: '/sources',
      name: 'Sources',
      component: () => import('@/components/endpoints/Sources.vue')
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('@/components/endpoints/Privacy.vue')
    },
    {
      path: '/maplinksgenerator',
      name: 'MapLinksGenerator',
      component: () => import('@/components/endpoints/MapLinksGenerator.vue')
    },
    {
      path: '/elementlinksgenerator',
      name: 'ElementLinksGenerator',
      component: () => import('@/components/endpoints/ElementLinksGenerator.vue')
    },
    {
      path: '/candidatepartition',
      name: 'CandidatePartition',
      component: () => import('@/components/endpoints/CandidatePartition.vue')
    }
  ]
})
